import { PortalWorkoutPlanFragment } from '@willow/graphql-iso/src/portal';
import { assertNever } from '@willow/shared-web';

import { AlertWrapper } from './AlertWrapper';

export const OfferedWorkoutPlanAlert = ({ offeredWorkoutPlan }: { offeredWorkoutPlan: PortalWorkoutPlanFragment }) => {
  switch (offeredWorkoutPlan.__typename) {
    case 'PaymentDeferralWorkoutPlan':
      return (
        <AlertWrapper
          title="Deferral offer pending"
          subtitle="Payment may change terms and cancel deferral offer"
          level="ERROR"
        />
      );
    case 'FlexModificationWorkoutPlan':
    case 'ForbearanceWorkoutPlan':
    case 'RepaymentWorkoutPlan':
    case 'DefermentWorkoutPlan':
      // These plans havent implemented an offered status yet
      return <></>;
    default:
      assertNever(offeredWorkoutPlan);
  }
};
